import { Component, OnInit, Input } from '@angular/core';
import { RecordsService } from '../services/records.service';
import { Label, MultiDataSet } from 'ng2-charts';
import { ChartType } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-charteyears',
  templateUrl: './charteyears.component.html',
  styleUrls: ['./charteyears.component.css']
})
export class CharteyearsComponent implements OnInit {

  public link: string = 'http://trad.fondation.org.ma:8090/api/anneedition';
  public totale: number = 0;
  public bdr: number = 0;
  public def: number = 0;

  @Input() set linkv(val: string)
  {
    this.link = val;
    this.doughnutChartLabels = [];
    this.doughnutChartData = [[]];
    this.doughnutChartType = 'line';
    this.Years();
  }

  @Input() set lcount(val: string) {
    this.bdr = parseInt(val);
  }

  public years: any;
  
  doughnutChartLabels: Label[] = [];
  doughnutChartData: MultiDataSet = [[]];
  doughnutChartType: ChartType = 'line';
  public options:any = {
    responsive: true,
    legend: {
        display: true,
        labels: {
            fontColor: '#6c757d',
            fontFamily: "'Raleway', 'Tajawal', sans-serif",
            size: 22
        }
    },
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }]
    }
  };

  
  constructor(private recordservice: RecordsService,public translate: TranslateService) { }

  ngOnInit(): void {
    this.Years();
  }

  public Years() {

    //if(this.bdr==0) this.bdr = this.recordservice.nbtout;
    this.totale = 0;
    this.recordservice.getFilters(this.link)
    .subscribe(data => {
      this.years = data;
      let i:number = 0;
      this.totale = 0;
      for (let index = this.years.length-1; index >= 0; index--) {
        this.doughnutChartData[0][i] = this.years[index]['y'];
        if(this.translate.currentLang == 'fr') { this.doughnutChartLabels[i] = this.years[index]['name'].replace('،', ''); }
        else { this.doughnutChartLabels[i] = this.years[index]['name'].replace('،', '').replace('Avant ', ' قبل');}
        this.totale += parseInt(this.years[index]['y']);
        i++;
      }
      
      // this.def = this.bdr - this.total;
      
      // this.doughnutChartData[0][this.years.length] = this.def;
      // this.doughnutChartLabels[this.years.length] = 'Autres - أخرى';

    }, err =>{
      console.log(err);
    });
  }

  chartClicked(e: any){
    console.log(e);
  }

}
